import { merchantApi } from '@/config/axios'

/** 律所机构端登录（/firm-api） */
export function firmLogin(data: { username: string; password: string }) {
  return merchantApi.post<{
    accessToken: string
    refreshToken: string
    expiresTime?: string
    accountId: number
    firmId: number
    accountType: number
    firmName?: string
  }>({ url: '/firm-api/auth/login', data })
}

export function firmLogout() {
  return merchantApi.post({ url: '/firm-api/auth/logout' })
}

export function getFirmAuthInfo() {
  return merchantApi.get({ url: '/firm-api/auth/info' })
}

export function getFirmWorkbenchContext() {
  return merchantApi.get<{
    accountId: number
    firmId: number
    firmName: string
    accountType: number
    permissions: string[]
    firmStatus?: string
    canonical?: boolean
    bizMode?: string
    lawyerCount?: number
    opportunityCount?: number
    caseCount?: number
    assignableCount?: number
    servingCount?: number
    pendingLawyerCount?: number
    pendingSettleCount?: number
    firmErpEnabled?: boolean
    firmSettleEnabled?: boolean
  }>({ url: '/firm-api/workbench/context' })
}
